import React, { useEffect, useState } from 'react';
import { useT } from '../i18n/LanguageContext';
import logoDouroNostrum from '../assets/logo_douronostrum_mono.svg';

const STORAGE_KEY = 'dn_age_confirmed';

/**
 * AgeGate — Modal de confirmação de idade (18+).
 * Bloqueia a interacção com o site enquanto o utilizador não confirma.
 * O resultado é guardado em localStorage para não voltar a aparecer.
 *
 * Fundo: a imagem do site (a hero atrás) fica visível através de um
 * overlay escuro — pediu-se ao cliente "pode já ser a mostrar a imagem
 * só que não deixa navegar se não disser que tem mais de 18 anos".
 */
export default function AgeGate() {
  const t = useT();
  const [confirmed, setConfirmed] = useState(true); // assume confirmado para evitar flash inicial
  const [denied, setDenied]       = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      if (v !== 'yes') setConfirmed(false);
    } catch {
      setConfirmed(false);
    }
  }, []);

  // Bloqueia scroll do body enquanto o gate está aberto
  useEffect(() => {
    if (!confirmed) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [confirmed]);

  if (confirmed) return null;

  const handleConfirm = () => {
    try { window.localStorage.setItem(STORAGE_KEY, 'yes'); } catch {}
    setConfirmed(true);
  };

  const handleDeny = () => {
    setDenied(true);
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(14, 7, 4, 0.85)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        padding: 'var(--sp-6)',
      }}
    >
      <div
        style={{
          maxWidth: '480px',
          width: '100%',
          textAlign: 'center',
          color: '#ffffff',
        }}
      >
        <img
          src={logoDouroNostrum}
          alt="Douro Nostrum"
          style={{
            width: '200px',
            height: 'auto',
            display: 'block',
            margin: '0 auto var(--sp-8)',
            filter: 'brightness(0) invert(1)',
          }}
        />
        <h2
          id="age-gate-title"
          style={{
            color: '#ffffff',
            marginBottom: 'var(--sp-4)',
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            fontWeight: 'var(--fw-medium)',
            lineHeight: 1.3,
          }}
        >
          {t('age.title')}<br />
          <span style={{ whiteSpace: 'nowrap' }}>{t('age.brand')}</span>
        </h2>

        {!denied ? (
          <>
            <p
              style={{
                color: 'rgba(255,255,255,0.75)',
                marginBottom: 'var(--sp-8)',
                lineHeight: 1.55,
              }}
            >
              {t('age.lead')}
            </p>
            <div
              style={{
                display: 'flex',
                gap: 'var(--sp-4)',
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              <button
                type="button"
                onClick={handleConfirm}
                className="btn btn-lg btn--on-dark"
              >
                {t('age.confirm')}
              </button>
              <button
                type="button"
                onClick={handleDeny}
                className="btn btn-lg btn--on-dark"
                style={{ opacity: 0.6 }}
              >
                {t('age.deny')}
              </button>
            </div>
          </>
        ) : (
          <p
            style={{
              color: 'rgba(255,255,255,0.85)',
              lineHeight: 1.55,
              marginTop: 'var(--sp-4)',
            }}
          >
            {t('age.denied')}
          </p>
        )}
      </div>
    </div>
  );
}
